import { isValidUuidV7 } from '@nudool/shared';

/** A focus key is a document id, a brand and part, or a brand, warehouse and part. */
export function isReorderFocusKey(value: string): boolean {
  const ids = value.split('.');
  return ids.length <= 3 && ids.every((id) => isValidUuidV7(id));
}
